import {
  FilteredItem,
  FilteredItemProps,
} from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import { GatewayTokenModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tokens/models/outputs/gateway-token.model';
import { TokenIsValid } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/token/token-is-valid.enum';
import { useTranslation } from 'react-i18next';

export interface TokenIsValidFilterStateControllerProps {
  value?: GatewayTokenModel['valid'];
  onRemove: FilteredItemProps['onRemove'];
}

export const TokenIsValidFilterStateController = ({
  value,
  onRemove,
}: TokenIsValidFilterStateControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const tokenIsValid = value
    ? TokenIsValid.VALID
    : value === false
      ? TokenIsValid.INVALID
      : TokenIsValid.ALL;

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <FilteredItem
      icon="electric-car-2"
      label={t(`delmonicos-shared-sdk.outputs-token-is-valid.${tokenIsValid}`)}
      onRemove={onRemove}
    />
  );
};
